import Vue from 'vue';

function AddOn(config) {
	if (!(this instanceof AddOn)) {
		return new AddOn(config);
	}
	if (config) {
		Vue.util.extend(this, config);
	}
}

AddOn.prototype = {
	constructor: AddOn,

	amount: 0,
	description: '',
	interval: '',
	name: '',
	order: 0,
	type: '',
	isTrial: false,
	hasTrial: false,
	hasPrereqs: false,
	disclaimer: '',
	shortName: '',

	setHasPrereqs: function () {
		this.hasPrereqs = true;
	},
	setDisclaimer: function(disclaimerText) {
		this.disclaimer = disclaimerText;
	},
	setShortName: function(name) {
		this.shortName = name;
	}
};

function getPrereqDetails(addOn){
	addOn.setHasPrereqs();
	return addOn;
}

function getAddOnDetails(addOn) {
	let name = addOn.name.toLowerCase().replace(/-|\s/g, '');
	if (name.includes('multiscope') || name.includes('bench')) {
		return getPrereqDetails(addOn);
	} else {
		return addOn;
	}
}

AddOn.fromDTO = function(dto) {
	const hasTrial = dto.hasTrial;
	let addOn = new AddOn({
		checked: dto.checked,
		amount: dto.amount,
		amountDue: hasTrial ? 0 : dto.amount,
		description: dto.description,
		interval: dto.interval,
		name: dto.name,
		order: dto.order,
		type: dto.type,
		isTrial: dto.isTrial,
		hasTrial: hasTrial

	});

	getAddOnDetails(addOn);

	return addOn;
};


export default AddOn;



// WEBPACK FOOTER //
// ./src/store/models/add-on.js